<template>
	<div class="about">
		<ht-view ref="htView" class="ht-view" type="3d" :auto-invalidate="true"></ht-view>
	</div>
</template>

<script>
export default {
	name: 'Case2',
	mounted(){
		var htView = this.$refs.htView;
		this.initHtView(htView.getDataModel(), htView.getGraphView());
	},
	methods: {
		initHtView(dataModel, graphView){
            graphView.enableToolTip();
            graphView.deserialize('scenes/HTbuilding.json');
		}
	}
}
</script>

<style lang="scss" scoped>
.ht-view{
	width: 80vw;
	height: 70vh;
	margin: auto;
	border: 1px solid #ccc;
}
</style>
